function clone(obj) {
    return obj ? JSON.parse(JSON.stringify(obj)) : null;
}

function saveText(text, fileName) {
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    setTimeout(() => {
        let blob = new Blob([text], { type: 'text/plain' });
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    });
}

export default {
    clone,
    saveText
};



// WEBPACK FOOTER //
// ./src/utils.js